import { NavigateFunction, NavigateOptions } from 'react-router'
import { AppDispatch } from '../../app/store'
import { setPage } from '../../features/environment/environmentSlice'

export function navigatePage(dispatch: AppDispatch, navigate: NavigateFunction, to: string, options?: NavigateOptions) {
  dispatch(setPage(to))
  navigate(to, options)
}
